import { RootState } from "@/modules/common";

export const selectProductAmount = (id: string) => (state: RootState) =>
  state.basket.basket.products.find(product => product.productId === id)
    ?.quantity ?? 0;
